import { checkInPlugins } from './registry';
import type { CheckInCustomizationContext, SurveyJsonPayload } from './types';

export const augmentCheckInSurvey = (
  rawSurveyData: string,
  context: CheckInCustomizationContext,
): string => {
  try {
    const parsed = JSON.parse(rawSurveyData) as SurveyJsonPayload;
    const augmented = checkInPlugins.reduce(
      (payload, plugin) => plugin.augment(payload, context),
      parsed,
    );
    return JSON.stringify(augmented);
  } catch (_err) {
    return rawSurveyData;
  }
};
